import './plugins/instructions';
import './plugins/control';
import instructions,{Instructions} from './plugins/create';

export default instructions;

export {Instructions};